import { Button } from '@library/components/buttons';
import { cn } from '@library/component-utils/cn';

export interface IconButtonProps {
  children: React.ReactNode;
  className?: string;
  dataTestId?: string;
  handleOnClick: () => void;
}

export const IconButton = ({
  children,
  className = '',
  dataTestId = 'IconButton',
  handleOnClick
}: IconButtonProps) => {
  return (
    <Button
      className={cn('hover:bg-soFresh-140', className)}
      data-testid={dataTestId}
      onClick={handleOnClick}
      type="button"
    >
      {children}
    </Button>
  );
};
